import * as Realm from 'realm-web';
import axios from "axios";
import { v4 as uuidv4 } from 'uuid';

const app = new Realm.App({ id: process.env.REACT_APP_MNDB_RELM_MAIN });
const user = require('../data/data-user-accounts.json').data;

export const AuthMailUser = async(username, passcode) => {
  const usrx = user.find(item => item.mail === username)
  if (usrx) {
    if (passcode === "skillset") return {code: 200, text:'Success', data: {...usrx, usid:usrx.enid}}
    else return {code: 403, text:'Failed: Incorrect Passcode', data: false}
  } 
  else return {code: 404, text:'Failed: User Not Found', data: false}
}

export const AuthLoginWebbUser = async() => {
  //login with webb
  const credentials = Realm.Credentials.apiKey(process.env.REACT_APP_MNDB_AUTH_APIK);
  return (await app.logIn(credentials))
}

export const AuthSessionX = async() => {
  localStorage.clear();
  localStorage.setItem("user",null);
  window.location.href='/'
}

export const SetAuthUser = (data) => {
  localStorage.setItem('user', JSON.stringify(data));
}

export const GetAuthUser = () => {
  return JSON.parse(localStorage.getItem("user"));
}

export const GetBaseAccount = async(item) => {
  const user = await AuthLoginWebbUser();
  const result = await user.functions.acntGetBaseAccount(item);
  return (result);
}

export const GetAccountBalance = async(item) => {
  const user = await AuthLoginWebbUser();
  const result = await user.functions.acntGetAccountBalance(item);
  return (result);
}

export const GetMarketOffers = async(data) => {
  const user = await AuthLoginWebbUser();
  const result = await user.functions.srvcGetOfferList(JSON.stringify({
    body: {webb: process.env.REACT_APP_WEBB_SITE_NMBR}, user: {}
  }))
  return (result); 
}

export const GetUserAccountsList = async(data) => {
  const user = await AuthLoginWebbUser();
  const result = await user.functions.acntGetUserAccounts(data)
  return (result); 
}

export const GetUserTransfersList = async(data) => {
  const user = await AuthLoginWebbUser();
  const result = await user.functions.trxnGetUserTransactionsList(data)
  return (result); 
}

export const GetUserContactsList = async (item) => {
  const user = await AuthLoginWebbUser();
  const result = await user.functions.contGetContactList(item)
  return (result);
}

export const GetUserTeamList = async(data) => {
  const user = await AuthLoginWebbUser();
  const result = await user.functions.teamGetTeamList(data)
  return (result); 
}

export const SearchUserProfile = async(item) => {
  const user = await AuthLoginWebbUser();
  const result = await user.functions.credGetUserProfile(item)
  return (result); 
}

export const GetRoomList = async(data) => {
  const user = await AuthLoginWebbUser();
  const result = await user.functions.roomGetRoomsList(data)
  return (result); 
}

export const GetRoomText = async(data) => {
  const user = await AuthLoginWebbUser();
  const result = await user.functions.roomGetRoomsText(data)
  return (result); 
}

export const CreateRoomText = async(data) => {
  const user = await AuthLoginWebbUser();
  const result = await user.functions.roomSubmitText(data)
  return (result); 
}